import {InviteDeviceType, IInviteFlowManager} from '../../../_contracts/InviteContracts';
import {AgentGuidanceItem} from '../../components/guidance-progress/GuidanceProgress';
import {EVENT_TYPES} from '../../../../../services/ts-sms/ts-sms.settings';
import {isScreenOrAppMirroring, buildWaitingGuidanceItems} from '../_Shared';

/**
 * Get guidance items based on the current mode and status
 * This function is designed to be extended for future modes (video, photo, etc.)
 */
export function getGuidanceItemsForMode(
    flowManager: IInviteFlowManager,
    deviceType: InviteDeviceType,
    guidanceType: string,
    guidanceText: string,
    latestStatus: string,
    translate: (key: string) => string
): AgentGuidanceItem[] {
    const isNativeFullAssist = flowManager.inviteMethodController.isNativeFullAssistSelected;
    if (latestStatus !== EVENT_TYPES.WAITING_FOR_CLIENT) {
        return getDefaultGuidanceItems(deviceType, guidanceType, guidanceText, translate);
    }

    // WiFi Analysis mode (Native Full Assist)
    if (isNativeFullAssist) {
        return buildWaitingGuidanceItems('wifi-analysis-waiting', deviceType, translate);
    }

    // Screen or App Mirroring mode
    if (isScreenOrAppMirroring(flowManager.inviteState.sessionInfo.meetingMode)) {
        return buildWaitingGuidanceItems('screen-mirroring-waiting', deviceType, translate);
    }

    // Default mode - single guidance item
    return getDefaultGuidanceItems(deviceType, guidanceType, guidanceText, translate);
}

/**
 * Default mode - single guidance item
 */
export function getDefaultGuidanceItems(
    deviceType: InviteDeviceType,
    guidanceType: string,
    guidanceText: string,
    translate: (key: string) => string
): AgentGuidanceItem[] {
    const deviceSuffix = deviceType === InviteDeviceType.android ? 'ANDROID' : 'IOS';
    const isIos = deviceType === InviteDeviceType.ios;

    return [
        {
            stepType: guidanceType,
            stepNum: 1,
            stepText: translate(guidanceText + deviceSuffix),
            deviceType: deviceType,
            tooltipPosition: {
                left: isIos ? '11%' : '19%'
            }
        }
    ];
}
